import axios from 'axios';

import { createFragment } from '@jsmdg/react-fragment-scripts/fragment';
import { getTenantConfig } from '../shared/tenantConfig';
import { type RootComponentProps } from '../shared/types';
import { ProductDetailWrapper } from './components/ProductDetailWrapper';
import {
    addItemToCartAtUrl,
    createAddToCartButtonClickedEvent,
    fetchPlacesDetail,
    fetchPlacesSuggestions,
} from './services';
import { type AddCartItemArgs, type ProductDetailContext } from './types/types';

async function initDependencies({ baseUrl }: { baseUrl?: string }): Promise<void> {
    axios.defaults.baseURL = await Promise.resolve(baseUrl);
}

const { Fragment, init } = createFragment<RootComponentProps, ProductDetailContext>(
    ProductDetailWrapper,
    ({ rootComponentProps }) => {
        const {
            algoliaConfig,
            customerState,
            featureFlagsVariation,
            initialWishlist,
            isBoxProductWithQrCodeLink,
            isMydays,
            locale,
            product,
            redemptionInformation,
            reviewPartnerAppKey,
            reviewPartnerScriptUrl,
            sharedData,
            tenant,
            xmasNoticesJson,
        } = rootComponentProps;

        return {
            addItemToCart: async ({ productId, quantity, valueVoucherPrice }: AddCartItemArgs) =>
                addItemToCartAtUrl({
                    productId,
                    quantity,
                    valueVoucherPrice,
                }),
            algoliaConfig,
            createAddToCartButtonClickedEvent,
            customerState,
            featureFlagsVariation,
            getPlacesDetail: async (placeId: string, sessionToken: string) =>
                fetchPlacesDetail({
                    placeId,
                    sessionToken,
                    locale,
                }),
            getPlacesSuggestions: async (input: string, sessionToken: string) =>
                fetchPlacesSuggestions({
                    input,
                    sessionToken,
                    locale,
                }),
            initialWishlist,
            isBoxProductWithQrCodeLink,
            isMydays,
            locale,
            product,
            redemptionInformation,
            reviewPartnerAppKey,
            reviewPartnerScriptUrl,
            tenant,
            tenantConfig: {
                ...getTenantConfig(tenant),
                ...sharedData,
            },
            xmasNoticesJson,
        };
    },
    initDependencies,
);

export { Fragment, init };
